import React from "react";
import PropTypes from "prop-types";
import { Grid, TextField, Button } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useSnackbar } from "components/GlobalSnackbar";
import { useConfirmDialog } from "components/ConfirmDialog";
import { searchBoxStyles } from "utils/pageHeaderStyles";
import { buttonStyles } from "utils/buttonStyles";
// MDInput and table head cells removed for this simplified search-only UI

function TerimaanSearch({
  searchNama,
  onSearchNamaChange,
  searchNoKp,
  onSearchNoKpChange,
  noAkaun,
  onNoAkaunChange,
  displayAkaunData,
  loading,
  selectedAkaun,
  onSelectAkaun,
}) {
  const { showSuccess, showError } = useSnackbar();
  const { showConfirm } = useConfirmDialog();
  const [isRebuilding, setIsRebuilding] = React.useState(false);

  const handleRebuildAllGlobal = async () => {
    try {
      const confirmed = await showConfirm({
        title: 'Rebuild Semua Lejar (Global)',
        message: 'Anda pasti mahu Rebuild Lejar untuk semua akaun (semua bahagian)? Proses ini mungkin mengambil masa.',
        confirmText: 'Rebuild',
        type: 'warning'
      });
      if (!confirmed) return;
      setIsRebuilding(true);
      const { fetchWithCsrfRetry } = await import("api/csrf");
      const resp = await fetchWithCsrfRetry(`/api/lejar/rebuild-all-global`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ onlyAktif: true }),
      });
      if (!resp.ok) throw new Error("Gagal rebuild lejar semua bahagian.");
      const result = await resp.json();
      const msg = `Rebuild siap: ${result.processed}/${result.total} akaun.` +
        (result.errors && result.errors.length ? ` Ralat: ${result.errors.length}` : "");
      window.appNotify && window.appNotify({ color: 'success', icon: 'check_circle', title: 'Berjaya', content: msg });
    } catch (err) {
      console.error("Global rebuild lejar failed:", err);
      window.appNotify && window.appNotify({ color: 'error', icon: 'error', title: 'Ralat', content: 'Gagal rebuild lejar semua bahagian.' });
    } finally {
      setIsRebuilding(false);
    }
  };
  return (
      <MDBox sx={searchBoxStyles.container}>
        <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 1.5 }}>
          <Grid item>
            <MDTypography variant="h6" fontWeight="bold">
              Carian
            </MDTypography>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              size="small"
              startIcon={<RefreshIcon />}
              onClick={handleRebuildAllGlobal}
              disabled={isRebuilding}
              sx={buttonStyles.primary}
            >
              Rebuild Lejar
            </Button>
          </Grid>
        </Grid>
        <Grid container spacing={1.5} alignItems="center" mb={2}>
          <Grid item xs={12} md={4} sx={{ mb: 2 }}>
            <TextField
              label="Nama"
              name="nama"
              size="small"
              value={searchNama}
              onChange={onSearchNamaChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={4} sx={{ mb: 2 }}>
            <TextField
              label="No KP"
              name="no_kp"
              size="small"
              value={searchNoKp}
              onChange={onSearchNoKpChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={4} sx={{ mb: 2 }}>
            <TextField
              label="No Akaun"
              name="no_akaun"
              size="small"
              value={noAkaun}
              onChange={onNoAkaunChange}
              fullWidth
            />
          </Grid>
        </Grid>
      </MDBox>
  );
}

export default React.memo(TerimaanSearch);

TerimaanSearch.propTypes = {
  searchNama: PropTypes.string,
  onSearchNamaChange: PropTypes.func.isRequired,
  searchNoKp: PropTypes.string,
  onSearchNoKpChange: PropTypes.func.isRequired,
  noAkaun: PropTypes.string,
  onNoAkaunChange: PropTypes.func.isRequired,
  displayAkaunData: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool,
  selectedAkaun: PropTypes.shape({
    noakaun: PropTypes.string,
    no_akaun: PropTypes.string,
  }),
  onSelectAkaun: PropTypes.func.isRequired,
};

TerimaanSearch.defaultProps = {
  searchNama: "",
  searchNoKp: "",
  noAkaun: "",
  loading: false,
  selectedAkaun: null,
};